import React, { Component } from "react";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import Flatpickr from "react-flatpickr"
import "chartist/dist/scss/chartist.scss";
import "../../../../assets/scss/chartist.scss";
import NoProject from "./charts/noProject";
import StatePiechart from "./charts/stateChart";
import Barchart from "./charts/barChart";
import RSBarChart from "components/charts/RSBarChart";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import PropTypes from "prop-types";
import RSPieChart from "components/charts/RSPieChart";

class BuilderChart extends Component {
    constructor(props) {
      super(props);
      this.state = {};
    }
    componentDidMount() {
        this.fetchProjectHistory();
        this.fetchCitiesProject();
        this.fetchProjectPerformance();
      }
      fetchProjectHistory = async () => {
        const { builderId } = this.props; 
        const agentId = localStorage.getItem("userId");
        const year = "2025";
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const url = `${API_URL}Builder/getBuilderHistoryDashboardByAgent?agentId=${agentId}&builderId=${builderId}`;
      
        try {
          const response = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
          });
      
          if (response.data && Array.isArray(response.data) && response.data.length > 0) {
            const sources = response.data.map((item) => item.sources);
            const counts = response.data.map((item) => item.counts);
      
            this.setState({
              barchartdata: {
                series: [{ name: "# Project", data: counts }],
                options: {
                  chart: { type: "bar", toolbar: { show: false } },
                  plotOptions: { bar: { horizontal: false, columnWidth: "50%" } },
                  dataLabels: { enabled: false },
                  colors: ["#195772"],
                  grid: { borderColor: "#f1f1f1" },
                  xaxis: { categories: sources },
                  height: 300,
                  fill: { opacity: 1 },
                 
                  legend: {
                    show: true,
                    position: "bottom",
                    horizontalAlign: "center",
                    verticalAlign: "middle",
                    fontSize: "14px"
                  },
                },
              },
            });
          }
        } catch (error) {
          this.setState({ error: error.message });
        }
      };
      fetchProjectPerformance = async () => {
        const { builderId } = this.props; 
        const agentId = localStorage.getItem("userId");
        const year = "2025";
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const url = `${API_URL}Builder/getBuilderPerformanceDashboardByAgent?agentId=${agentId}&builderId=${builderId}`;
      
        try {
          const response = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
          });
      
          if (response.data && Array.isArray(response.data) && response.data.length > 0) {
            const sources = response.data.map((item) => item.sources);
            const counts = response.data.map((item) => item.counts);
      
            this.setState({
              barchartPerformance: {
                series: [{ name: "# Project", data: counts }],
                options: {
                  chart: { type: "bar", toolbar: { show: false } },
                  plotOptions: { bar: { horizontal: false, columnWidth: "50%" } },
                  dataLabels: { enabled: false },
                  colors: ["#195772"],
                  grid: { borderColor: "#f1f1f1" },
                  xaxis: { categories: sources },
                  height: 300,
                  fill: { opacity: 1 },
                 
                  legend: {
                    show: true,
                    position: "bottom",
                    horizontalAlign: "center",
                    verticalAlign: "middle",
                    fontSize: "14px"
                  },
                },
              },
            });
          }
        } catch (error) {
          this.setState({ error: error.message });
        }
      };
      fetchCitiesProject = async () => {
        const { builderId } = this.props; 
        const agentId = localStorage.getItem("userId");
        const year = "2025";
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const url = `${API_URL}Builder/getBuilderCityDashboardByAgent?agentId=${agentId}&builderId=${builderId}`;
    
        try {
          const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
            if (response.data && Array.isArray(response.data)) {
          
              const sources = response.data.map(item => item.sources);
              const counts = response.data.map(item => item.counts1);
            this.setState({
              leadSourceData: {
                series: counts,
                options: {
                  chart: { type: "pie" },
                  labels: sources,
                  colors: ["#004aad", "#ffbd59", "#cb6ce6", "#ff6d4d", "#14891c"],
                  legend: {
                    show: true,
                    position: "bottom",
                    horizontalAlign: "center",
                    verticalAlign: "middle",
                    floating: false,
                    fontSize: "14px",
                    offsetX: 0,
                    offsetY: -10,
                  },
                  responsive: [{ breakpoint: 600, options: { chart: { height: 440 }, legend: { show: false } } }],
                },
              },
            });
          }
        } catch (error) {
          this.setState({ error: error.message });
        }
      }; 
    render() {
        return (
        <React.Fragment>
             <Container fluid={true} className="ps-0 pe-0">
            
            
                   
                <Row>
                    <Col sm="6"className="d-flex">
                                        <Card className="border-full mt-4 w-100">
                                          <CardBody className="d-flex flex-column">
                   
                    <h4 style={{textAlign:"left"}}>Project history</h4>
                         
                              {this.state.barchartdata && <RSBarChart filter={false} title="" {...this.state.barchartdata} />}
                      </CardBody>
                </Card>
                    </Col>
                    <Col sm="6" className="d-flex">
                                        <Card className="border-full mt-4 w-100">
                                          <CardBody className="d-flex flex-column">
                    <h4 style={{textAlign:"left"}}>Project by cities</h4>
                            {this.state.leadSourceData && <RSPieChart filter={false} title="" {...this.state.leadSourceData} />} 
                    </CardBody>
                </Card>
                    </Col>
                    {/* <Col sm="4" className="d-flex">
                                        <Card className="border-full mt-4 w-100">
                                          <CardBody className="d-flex flex-column">
                    <h4 style={{textAlign:"left"}}>Project performance</h4>
                    
                    {this.state.barchartPerformance && <RSBarChart filter={false} title="" {...this.state.barchartPerformance} />}
                    
                   </CardBody>
                </Card>
                    </Col> */}
                </Row>
              
             </Container>
        </React.Fragment>
        )
    }
}
BuilderChart.propTypes = {
  match: PropTypes.object,
  builderId:PropTypes.object
}

export default BuilderChart;